import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-fancy-card-back',
  templateUrl: './fancy-card-back.component.html',
  styleUrls: ['./fancy-card-back.component.scss']
})
export class FancyCardBackComponent {

  @Input() securityCode: string = "";

  hiddenSecurityCode: string = "";

  ngOnChanges() {
    this.hiddenSecurityCode = "*".repeat(this.securityCode.length);
  }
}
